import type * as React from 'react'

import { Dialog, Button } from '@buffer-mono/popcorn'

import type { Service } from '../../types'
import { getSocialNetworkName } from '../../utils/getSocialNetworkName'
import styles from './ExitChannelConnectionDialog.module.css'

export function ExitChannelConnectionDialog({
  onOpenChange,
  setShowExitChannelConnectionDialog,
  selectedService,
}: {
  onOpenChange: () => void
  setShowExitChannelConnectionDialog: React.Dispatch<
    React.SetStateAction<boolean>
  >
  selectedService: Service | null
}) {
  const socialNetworkName = getSocialNetworkName(selectedService)
  const heading = socialNetworkName
    ? `${socialNetworkName} Connection in Progress`
    : 'Connection in Progress'
  const message = socialNetworkName
    ? `${socialNetworkName} is not fully connected yet. If you exit now, you will lose all progress.`
    : 'Your channel is not fully connected yet. If you exit now, you will lose all progress.'

  return (
    <Dialog open onOpenChange={() => setShowExitChannelConnectionDialog(false)}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title className={styles.heading}>{heading}</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <Dialog.Description>{message}</Dialog.Description>
        </Dialog.Body>
        <Dialog.Footer className={styles.footer}>
          <Button
            variant="tertiary"
            size="large"
            onClick={() => setShowExitChannelConnectionDialog(false)}
          >
            Continue Connection
          </Button>
          <Button
            className={styles.criticalButton}
            variant="critical"
            size="large"
            onClick={onOpenChange}
          >
            Exit Channel Connection
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
